module.exports = __webpack_public_path__ + "img/product_112.67396dd.webp";